import React from 'react'
import useMobileMode from '../../../hooks/useMobileMode'
import AuthService from '../../../services/authentication'
import OTPService from '../../../services/otp'
import ProfileService from '../../../services/profile'
import SessionService from '../../../services/session'
import Button from '../../atoms/Button/Button'
import LayoutModal from '../../organisms/layoutModal/layout-modal'
import ButtonLoading from '../buttonLoading/buttonLoading'
import InputPoints from '../input-points/input-points'
import './modalOTP.scss'

const ModalOTP = ({
	onClose,
	payload,
	actualStorage,
	setFormSubmit,
	type,
	passContentType,
	classname,
	currentSlider,
	setPasswordChanged,
	setCurrentUser,
	isAccount,
}) => {
	const [key, setKeys] = React.useState({
		isValid: true,
		error: '',
		key: '',
	})
	const totalInputs = 6
	const { isMobile } = useMobileMode()
	const [isLoaderVisible, setLoaderVisible] = React.useState(false)
	const [forwardedMessage, setforwardedMessage] = React.useState(false)
	const inputRef = React.useRef(null)

	const handleReSendKey = () => {
		setforwardedMessage(false)
		setKeys({ isValid: true, error: '', key: '' })
		OTPService.getKey(SessionService.getIdTokenData())
			.then(res => {
				if (res.status === 200) {
					setforwardedMessage(true)
				} else if (res.status === 400 || res.status === 500) {
					setKeys({ error: res.data.userMessage, isValid: false })
					setforwardedMessage(false)
				}
			})
			.catch(err => {
				console.log(err)
			})
	}

	const handleSendKey = async () => {
		setLoaderVisible(true)
		let value = ''
		Array(totalInputs)
			.fill(0)
			.map((x, index) => {
				return (value += inputRef.current[index].value.toUpperCase())
			})
		const payloadToSend = {
			...payload,
			otpKey: value,
		}
		if (type === 'userInfo') {
			await ProfileService.updateProfile(
				payloadToSend,
				res => {
					setLoaderVisible(false)
					if (res.data.status === 200) {
						setFormSubmit(true)
						const updatedData = JSON.stringify(res.data.data)
						actualStorage === 0
							? localStorage.setItem('userData', updatedData)
							: sessionStorage.setItem('userData', updatedData)
						setCurrentUser(res.data.data.name + ' ' + res.data.data.lastName)
						onClose()
					} else if (res.data.status === 400 || res.data.status === 500) {
						setKeys({ error: res.data.userMessage, isValid: false })
						setforwardedMessage(false)
					}
				},
				error => {
					setLoaderVisible(false)
					console.log(error)
				}
			)
		} else if (type === 'userPass') {
			AuthService.changeTempPassword(
				payloadToSend,
				SessionService.getIdTokenData()
			)
				.then(data => {
					if (data.status === 200) {
						onClose()
						passContentType === 1
							? setPasswordChanged(true)
							: currentSlider.current.slickNext()
					} else if (data.status === 400 || data.status === 500) {
						setKeys({ error: data.userMessage, isValid: false })
						setforwardedMessage(false)
					}
					setLoaderVisible(false)
				})
				.catch(err => {
					console.log(err)
					setLoaderVisible(false)
				})
		}
		// else if (type === "userRedeem") {
		//   BenefitsService.redeemPurchaseVouchers(payloadToSend, SessionService.getIdTokenData()).then(response => {
		//     if (response.status === constants.successStatus) {
		//       handleCorrectlyRedeem(true);
		//       hanldeModalConfirmationValues({ ...values, order: response.data.order, userPoints: response.data.userPoint });
		//       setWithoutEnoughPoints(false);
		//       setTimeout(() => {
		//         onClose();
		//         hideModalRedeem()
		//       }, 100);
		//     } else if (response.status === constants.failureStatus) {
		//       handleCorrectlyRedeem(false);
		//       setWithoutEnoughPoints(true);
		//       onClose();
		//     }
		//     setLoaderVisible(false);
		//   }).catch(err => { console.log(err); setLoaderVisible(false); })
		// }
	}

	return (
		<LayoutModal onClose={onClose}>
			<section className={`f-modal-otp ${classname}`}>
				<span className='f-alert-close' onClick={onClose}>
					X
				</span>
				<div className='f-modal-otp-content'>
					<h4>¡QUEREMOS VALIDAR QUE SEAS TÚ!</h4>
					<p className='f-p'>
						Ingresa el código de seguridad que enviamos a tu número celular
					</p>
					<div className='f-otp-key-content'>
						<InputPoints
							isAccount={isAccount}
							inputRef={inputRef}
							totalInputs={totalInputs}
							isValid={key.isValid}
							isVisible={true}
							errorMsg={key.error}
							isMobile={isMobile}
						/>
						<Button
							classname='f-button f-button--clear'
							text='¡No he recibido el mensaje!'
							type='button'
							onClickAction={handleReSendKey}
						/>
						{forwardedMessage && (
							<p className='f-key-forwarded'>
								Hemos reenvíado el código de seguridad, por favor revisa tu
								correo electrónico o teléfono registrado.
							</p>
						)}
					</div>
					<ButtonLoading
						button={
							<Button
								classname='f-button f-button--primary'
								text='CONTINUAR'
								type='button'
								onClickAction={handleSendKey}
							/>
						}
						isShowingLoader={isLoaderVisible}
						bgClass='primary'
					/>
					{/* <Button classname="f-button f-button--primary" text="CONTINUAR" type="button" onClickAction={handleSendKey}  /> */}
				</div>
			</section>
		</LayoutModal>
	)
}

export default ModalOTP
